// Import necessary libraries
import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

// Register required components
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const LineChart = ({ chartData, count, activeCount }) => {
  const monthLabels = chartData?.map((entry) => {
    const date = new Date(entry.month + "-01"); // Ensure it's parsed correctly
    return date.toLocaleString("default", { month: "short" }); // e.g., "Mar"
  });

  // Extract `compliant` and `nonCompliant` values from `chartData`
  const compliantData = chartData?.map((entry) => entry.compliant);
  const nonCompliantData = chartData?.map((entry) => entry.nonCompliant);
  const invitedData = chartData?.map((entry) => entry.invited);
  // Define data for chart
  const data = {
    // labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    labels: monthLabels,
    datasets: [
      {
        label: "Compliant",
        // data: [40, 50, 60, 65, 70, 80, 85, 90, 92, 93, 95, 100],
        data: compliantData,
        borderColor: "#86E5B2",
        backgroundColor: "rgba(134, 229, 178, 0.3)",
        pointBackgroundColor: "#3DB77E",
        pointBorderColor: "#fff",
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
        fill: true,
        lineTension: 0.4,
        borderWidth: 2,
      },
      {
        label: "Non-Compliant",
        // data: [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75],
        data: nonCompliantData,
        borderColor: "#F04438",
        backgroundColor: "#F04438",
        pointBackgroundColor: "#F04438",
        pointBorderColor: "#fff",
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
        fill: true,
        lineTension: 0.4,
        borderWidth: 2,
      },
      {
        label: "Invited",
        // data: [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75],
        data: invitedData,
        borderColor: "#0E4E9A",
        backgroundColor: "rgba(152, 162, 179, 0.3)",
        pointBackgroundColor: "#0E4E9A",
        pointBorderColor: "#fff",
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
        fill: true,
        lineTension: 0.4,
        borderWidth: 2,
      },
    ],
  };

  // Define chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Disable aspect ratio to allow custom sizing
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (tooltipItem) =>
            `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 12 } },
      },
      y: {
        beginAtZero: true,
        ticks: { font: { size: 12 } },
      },
    },
  };

  return (
    <div
      style={{
        width: "100%",
        height: "400px", // Set height of the chart container
        margin: "0 auto",
        paddingTop: "60px",
        position: "relative",
      }}
    >
      {/* Title on the left side */}
      <div style={{ position: "absolute", top: "0", left: "0" }}>
        <span className="text-gray-600 font-medium text-xs">
          Total Providers
        </span>
        <div className="text-gray-600 font-semibold text-sm">{count}</div>
      </div>

      {/* Custom Legend on the right side */}
      <div
        style={{
          position: "absolute",
          top: "0",
          right: "0",
          display: "flex",
          gap: "30px",
          alignItems: "center",
        }}
      >
        <div className="flex gap-3">
          <div
            className="mt-2"
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: "#3DB77E",
              borderRadius: "50%",
            }}
          ></div>
          <div>
            <span className="text-gray-600 font-medium text-xs">Compliant</span>
            <div className="text-gray-600 font-semibold text-sm">
              {activeCount?.compliant}
            </div>
          </div>
        </div>
        <div className="flex gap-3">
          <div
            className="mt-2"
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: "#F04438",
              borderRadius: "50%",
            }}
          ></div>
          <div>
            <span className="text-gray-600 font-medium text-xs">
              Non-compliant
            </span>
            <div className="text-gray-600 font-semibold text-sm">
              {activeCount?.nonCompliant}
            </div>
          </div>
        </div>

        <div className="flex gap-3">
          <div
            className="mt-2"
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: "#98A2B3",
              borderRadius: "50%",
            }}
          ></div>
          <div>
            <span className="text-gray-600 font-medium text-xs">Invited</span>
            <div className="text-gray-600 font-semibold text-sm">
              {activeCount?.invited}
            </div>
          </div>
        </div>
      </div>

      {/* Chart */}
      <div style={{ width: "100%", height: "100%" }}>
        <Line data={data} options={options} />
      </div>
    </div>
  );
};

export default LineChart;
